module.exports = __webpack_public_path__ + "static/img/4.fb1f45b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/eng/4.png
// module id = zNXE
// module chunks = 0